import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateShowSuspendWAModal } from '../../../../actions/modal.js';
import { suspendAccessWaitingArea, selectWaitingAreaEntity } from '../../../../actions/waitingArea.js';
import { getWAByIdWithSearchTerm } from 'actions/organisation';

export default function RightPanelSuspendWaitingArea(props) {
  const dispatch = useDispatch();
  const [updatingWAStatus, setUpdatingWAStatus] = useState(false);

  const closeModal = () => {
    dispatch(updateShowSuspendWAModal(false));
  };

  const suspendWA = () => {
    let cb = (showModal) => {
      if (!showModal) {
        let lastCb = (data) => {
          setUpdatingWAStatus(false);
          dispatch(selectWaitingAreaEntity(data));
          dispatch(updateShowSuspendWAModal(showModal));
        };
        dispatch(getWAByIdWithSearchTerm(props.waitingArea.id, props.waitingArea.orgNetworkId, lastCb));
      } else {
        setUpdatingWAStatus(false);
      }
    };
    setUpdatingWAStatus(true);
    let suspendMsgForCallers = props.getSuspendWAMsgForCallers || '';
    let suspendMsgForProviders = props.getSuspendWAMsgForProviders || '';
    let suspendMsgBody = {
      suspendedMessageCaller: suspendMsgForCallers,
      suspendedMessageProvider: suspendMsgForProviders,
    };
    dispatch(suspendAccessWaitingArea(props.waitingArea, suspendMsgBody, cb));
  };

  let saveClasses =
    'ui approve labeled icon button icon left-text color-button color-button-hover mrrxs color-white max-width  mrlnull mrbnull';

  return (
    <div className=" mrbs max-width mrtxxs">
      <button
        type="button"
        onClick={() => suspendWA()}
        className={updatingWAStatus ? saveClasses + ' loading' : saveClasses}
        data-group="suspendWAMessageForm"
      >
        {' '}
        {/* TODO - Add loading animation */}
        {APP.LANGUAGE.Yes}
        <i className="checkmark icon " />
      </button>

      <button
        onClick={() => closeModal()}
        type="button"
        className="ui cancel labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrtm mrlnull mrbnull"
      >
        <i className="remove  icon" />
        {APP.LANGUAGE.No}
      </button>
    </div>
  );
}
